import React from 'react'
import { Card } from 'react-bootstrap'

const VRWorksExample = () => {
  return (
    <>
        <Card className="no-border rounded-0 text-center container pt-md-5 mt-md-2">
            <Card.Title className='digital-twin-title'> VR開発実績の一例 </Card.Title>
            <Card.Text className='digital-twin-text text-left'>
            私たちは、これまで何百ものVRプロジェクトに携わってきました。ここでは、私たちが手がけた仕事の例をご紹介します。
            </Card.Text>
        </Card>
      
    </>
  )
}

export default VRWorksExample
